import { devicesGenerator } from "@/Case/sharedUserMediaFunctions/devicesGenerator";

export async function createMediaDevicesIterator(this: any) {
  if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
    this.devicesIterator = devicesGenerator([]);

    return 0;
  }

  const devices = await navigator.mediaDevices.enumerateDevices();

  const deviceIDs = devices.reduce((reduction: string[], device) => {
    if (device.kind === "videoinput") {
      reduction.push(device.deviceId);
    }

    return reduction;
  }, []);

  this.devicesIterator = devicesGenerator(deviceIDs);

  return deviceIDs.length;
}
